module.exports = __webpack_public_path__ + "img/ic_24_google.aa6e3d5b.svg";